import { PER_PAGE, sorts } from '../constants'
import { fetchWithTimeout, getSortByKey, withAuthHeaders } from './utils'

const RP_API_URL = process.env.REACT_APP_RP_API_URL
const DEFAULT_HEADERS = {
  'content-type': 'application/json',
}

/**
 * Query Api for active projects.
 * @param filters {Object} - The filters sent to Api to specify search criteria. Each property of filters
 *  is an array of strings (or empty) and is keyed by category (attending, department, positionType and topic).
 * @param pageNumber {Number} - The page to request from Api.
 * @param sortBy {String} - The attribute to sort the data on. We
 *  don't currently control ascending or descending.
 */
export const getActiveProjects = (filters, pageNumber, sortBy = sorts.NEWEST) => {
  const url = `${RP_API_URL}/surveyData/search`
  const init = {
    body: JSON.stringify({
      ...filters,
      pageNum: pageNumber,
      pageSize: PER_PAGE,
      [getSortByKey(sortBy)]: true,
    }),
    headers: withAuthHeaders(DEFAULT_HEADERS),
    method: 'POST',
  }
  return fetchWithTimeout(url, init).then((res) => res.json())
}

export const getProject = (id) => {
  const url = `${RP_API_URL}/surveyData/${id}`
  const init = {
    headers: withAuthHeaders(DEFAULT_HEADERS),
    method: 'GET',
  }
  return fetchWithTimeout(url, init).then((res) => res.json())
}

export const login = (campusKey, password, rememberMe) => {
  const url = `${RP_API_URL}/auth`
  const init = {
    body: JSON.stringify({
      username: campusKey,
      password,
      rememberMe,
    }),
    headers: DEFAULT_HEADERS,
    method: 'POST',
  }
  return fetchWithTimeout(url, init).then((res) => res.json())
}

export const getFilters = (urlFilters) => {
  const url = `${RP_API_URL}/list/${urlFilters}`
  const init = {
    headers: withAuthHeaders(DEFAULT_HEADERS),
    method: 'GET',
  }
  return fetchWithTimeout(url, init).then((res) => res.json())
}
